// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Recebimentos_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /recebimentos/save
 *
 * Creates or updates a recebimento (payment receipt).
 * If recebimento_id > 0, updates existing; otherwise creates new.
 */
import { registerContract } from './validate'

export interface Recebimentos_SaveInput {
recebimento_id?: number
recebimento_data?: string
recebimento_data_disponivel?: string
recebimento_franquia_id?: number
recebimento_forma_pagamento_id?: number
recebimento_valor?: number
recebimento_valor_taxas?: number
recebimento_valor_liquido?: number
recebimento_provedor?: string
recebimento_origem?: string
recebimento_origem_id?: number
recebimento_registrado_por?: string
recebimento_registrado_por_id?: string
recebimento_id_externo?: string
recebimento_conta_id?: number
recebimento_conta_externa_id?: number
recebimento_observacoes?: string
recebimento_payroll_period_id?: number
recebimento_numero_parcelas?: number
}

registerContract('Recebimentos_SaveInput', {
  recebimento_id:                 { type: 'number',  required: false },
  recebimento_data:               { type: 'string',  required: false },
  recebimento_data_disponivel:    { type: 'string',  required: false },
  recebimento_franquia_id:        { type: 'number',  required: false },
  recebimento_forma_pagamento_id: { type: 'number',  required: false },
  recebimento_valor:              { type: 'number',  required: false },
  recebimento_valor_taxas:        { type: 'number',  required: false },
  recebimento_valor_liquido:      { type: 'number',  required: false },
  recebimento_provedor:           { type: 'string',  required: false },
  recebimento_origem:             { type: 'string',  required: false },
  recebimento_origem_id:          { type: 'number',  required: false },
  recebimento_registrado_por:     { type: 'string',  required: false },
  recebimento_registrado_por_id:  { type: 'string',  required: false },
  recebimento_id_externo:         { type: 'string',  required: false },
  recebimento_conta_id:           { type: 'number',  required: false },
  recebimento_conta_externa_id:   { type: 'number',  required: false },
  recebimento_observacoes:        { type: 'string',  required: false },
  recebimento_payroll_period_id:  { type: 'number',  required: false },
  recebimento_numero_parcelas:    { type: 'number',  required: false },
})
